import React from 'react';
import styled from 'styled-components';
import useLocale from '../../hooks/useLocale';

const LEVEL_COLORS = {
  1: '#2E7D32',
  2: '#66BB6A',
  3: '#FFB300',
  4: '#EF6C00',
  5: '#D84315',
};

const LEVEL_LABEL_KEYS = {
  1: 'highlyFavorable',
  2: 'favorable',
  3: 'neutral',
  4: 'cautionary',
  5: 'unfavorable',
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${p => p.theme.spacing[3]}px;
  margin: ${p => p.theme.spacing[4]}px 0;

  @media (max-width: ${p => p.theme.breakpoints.mobile}px) {
    flex-direction: column;
    align-items: stretch;
    gap: ${p => p.theme.spacing[2]}px;
  }
`;

const Bar = styled.div`
  display: flex;
  gap: 4px;
  flex: 1;
  min-width: 160px;
`;

const Segment = styled.div`
  flex: 1;
  height: 14px;
  border-radius: 4px;
  background: ${p => p.filled ? p.fillColor : 'transparent'};
  border: 1.5px solid ${p => p.fillColor};
`;

const Label = styled.span`
  font-size: ${p => p.theme.typography.sizes.sm};
  font-weight: ${p => p.theme.typography.weights.semibold};
  color: ${p => p.color};
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};
  white-space: nowrap;
`;

const AuspiciousnessBar = ({ level, lang = 'en' }) => {
  const t = useLocale(lang, 'ganeshaPrashnavali');
  const safeLevel = [1, 2, 3, 4, 5].includes(level) ? level : 3;
  const color = LEVEL_COLORS[safeLevel];
  const label = t.auspiciousness?.[LEVEL_LABEL_KEYS[safeLevel]] || `Level ${safeLevel}`;
  const ariaLabelTemplate = t.auspiciousness?.aria || 'Auspiciousness: {label}, level {n} of 5';
  const ariaLabel = ariaLabelTemplate.replace('{label}', label).replace('{n}', safeLevel);

  return (
    <Container role="img" aria-label={ariaLabel}>
      <Bar>
        {[1, 2, 3, 4, 5].map(seg => (
          <Segment key={seg} filled={seg <= safeLevel} fillColor={color} />
        ))}
      </Bar>
      <Label color={color}>{label}</Label>
    </Container>
  );
};

export default AuspiciousnessBar;
